<template>
  <bike-form />
</template>

<script>
import BikeForm from '@/components/forms/BikeForm'
export default {
  components: {
    BikeForm
  }
}
</script>
